/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Body, POST, RebirthHttp } from 'rebirth-http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { setAdminResetPassword } from '../interfaces/reset-pass.interface';

@Injectable()
export class ResetPasswordService extends RebirthHttp {
  constructor(http: HttpClient) {
    super(http);
  }

  @POST(
    environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/setPassword'
  )
  setAdminResetPassword(
    @Body reg: setAdminResetPassword
  ): Observable<any> | any {
    return null; // leave `return null` due to TypeScript Interface isn't visable in runtime
  }
}
